import { DirectionalLight, PointLight, SpotLight } from "three";
// import { PointLightHelper } from "three";
// import { DirectionalLightHelper } from "three";

export const getLights = (lights, scene) => {
    const result = [];
    const lightsTargets = [];
    const typeLights = Object.keys(lights);
    typeLights.forEach((type) => {
        lights[type].forEach((params) => {
            const { pos, power, dist, decay, shadow } = params;
            if (type === "directionalLights") {
                const light = new DirectionalLight("white", power);
                light.castShadow = shadow;
                light.shadow.mapSize.width = 1024;
                light.shadow.mapSize.height = 1024;
                light.target.position.set(0, 1.5, -2.5);
                light.position.set(...pos);
                result.push(light);
                lightsTargets.push(light.target);

                // const helper = new DirectionalLightHelper(light, 0.1, "red");
                // scene.add(helper);
            }

            if (type === "shadowLights") {
                const light = new PointLight("white", power, dist, decay);
                light.position.set(...pos);
                light.castShadow = true;
                light.shadow.mapSize.width = 1024;
                light.shadow.mapSize.height = 1024;
                result.push(light);

                // const helper = new PointLightHelper(light, 0.1, "red");
                // scene.add(helper);
            }

            if (type === "mainLights") {
                const light = new PointLight("white", power, dist, decay);
                light.position.set(...pos);
                result.push(light);
                // const helper = new PointLightHelper(light, 0.1, "red");
                // scene.add(helper);
            }

            if (type === "wallLights") {
                const light1 = new SpotLight("white", power * 3);
                light1.distance = 1.8;
                light1.angle = 0.55;
                light1.penumbra = 1;
                light1.decay = 1.5;
                light1.position.set(pos[0], pos[1] + 0.05, pos[2]);
                light1.target.position.set(pos[0], 3, pos[2]);
                light1.castShadow = true;
                light1.shadow.mapSize.width = 1024;
                light1.shadow.mapSize.height = 1024;
                lightsTargets.push(light1.target);

                const light2 = new SpotLight("white", power * 3);
                light2.distance = 2.5;
                light2.angle = 0.7;
                light2.penumbra = 1;
                light2.decay = 1;
                light2.position.set(pos[0], pos[1] - 0.05, pos[2]);
                light2.target.position.set(pos[0], 0, pos[2]);
                light2.castShadow = true;
                light2.shadow.mapSize.width = 1024;
                light2.shadow.mapSize.height = 1024;
                lightsTargets.push(light2.target);

                const light3 = new SpotLight("white", power * 10);
                light3.distance = 0.3;
                light3.angle = 0.7;
                light3.penumbra = 0.5;
                light3.decay = 2;
                light3.position.set(...pos);
                light3.target.position.set(pos[0], 3, pos[2]);
                lightsTargets.push(light3.target);

                const light4 = new SpotLight("white", power * 10);
                light4.distance = 0.3;
                light4.angle = 0.7;
                light4.penumbra = 0.5;
                light4.decay = 2;
                light4.position.set(...pos);
                light4.target.position.set(pos[0], 0, pos[2]);
                lightsTargets.push(light4.target);

                const light5 = new PointLight("white", power);
                light5.distance = 1.5;
                light5.position.set(...pos);
                result.push(light1, light2, light3, light4, light5);
            }
        });
    });

    return [result, lightsTargets];
};
